import { createAction, type PayloadActionCreator } from '@reduxjs/toolkit';
import { type Network } from 'schemas';

const PREFIX = 'app';

function createAppAction<P = void>(actionName: string): PayloadActionCreator<P, string> {
  return createAction<P>(`${PREFIX}/${actionName}`);
}

/** Used to handle generic errors caught by the ErrorBoundary component */
export const catchAppError = createAppAction<void>('catchAppError');

/** Used in the start over function for resetting certain state after an error has occurred */
export const startOver = createAppAction('startOver');

/** Used to change the network and close the updateRegion modal */
export const handleNetworkChange = createAppAction<string>('handleNetworkChange');

/** Used to update entire Redux store from url params
 * @TODO Update payload type - include lastLocation from useStartOver hook
 */
export const updateStoreFromUrl = createAppAction<unknown>('updateStoreFromUrl');

/** A user has clicked "clear" all on the search form */
export const clearSearchForm = createAppAction<void>('clearSearchForm');

/** A user has clicked one of the marker icons on the map
 * @TODO Update payload type - include marker, bounds, mapHeight, longitude, latitude
 */
export const mapLocationClicked = createAppAction<unknown>('mapLocationClicked');

/** Used to show all results in a cluster
 * @TODO Update payload type - include coordinates, offset, clusterId
 */
export const showClusterResults = createAppAction<unknown>('showClusterResults');

/** A user has clicked an empty area on the map, not clicking any icons or markers */
export const mapClicked = createAppAction<void>('mapClicked');

/** The results page was unmounted */
export const resultsPageUnmounted = createAppAction<void>('resultsPageUnmounted');

/** Providers at facility page unmounted */
export const providersAtFacilityPageUnmounted = createAppAction<void>(
  'providerAtFacilityPageUnmounted'
);

export const networkChanged = createAppAction<{ newNetwork: Network | null }>('networkChanged');
